@import "../../../3d-party/monaco/editor.main";
@import "../../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
  --code-editor-border: 1px solid #{v(--border-strong-01)};
  --code-editor-border-radius: #{v(--border-radius)};
}

.code-editor-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: v(--spacing-02);
}

.code-editor-component {
  height: 100%;
  position: relative;

  .editor {
    height: 100%;
    min-height: 2rem;
    border: var(--code-editor-border);
    border-radius: var(--code-editor-border-radius);
    overflow: hidden;
  }

}

.read-only-tag {
  position: absolute;
  right: 9rem;
  z-index: 1;
  top: v(--spacing-05);
}

:host(.no-border) {
  .code-editor-component {
    .editor {
      border: none;
      border-radius: 0;
    }
  }
}


/**
 * States
 */
.code-editor-component.has-focus .editor {
  @include focus-ring;
  border-color: transparent;

}

@each $state in [success, warning, error] {
  :host-context(.input-state-#{$state}) {
    .code-editor-component {
      .editor {
        border-color: v(--support-#{$state});
      }

      &.has-focus {
        .editor {
          @include focus-ring(var(--support-#{$state}));
        }
      }
    }
  }
}
